export default {
  FINANCE: 'FINANCE',
  ADMIN: 'ADMIN',
  AV_ADMIN: 'AV_ADMIN',
  SUPPORT: 'SUPPORT',
  SALES: 'SALES',
};
